import { animate, state, style, transition, trigger } from '@angular/animations';

export const HOME_ANIMATIONS = [
    trigger('slideUpFade', [
        state('hidden', style({
            opacity: 0,
            transform: 'translateY(30px)'
        })),
        state('visible', style({
            opacity: 1,
            transform: 'translateY(0)'
        })),
        transition('hidden => visible', [
            animate('700ms cubic-bezier(0.25, 0.8, 0.25, 1)')
        ]),
        transition('visible => hidden', [
            animate('500ms cubic-bezier(0.25, 0.8, 0.25, 1)')
        ])
    ]),
    trigger('expandableContent', [
        state('collapsed', style({
            height: '0px',
            opacity: 0,
            overflow: 'hidden'
        })),
        state('expanded', style({
            height: '*',
            opacity: 1,
            overflow: 'visible'
        })),
        transition('collapsed => expanded', [
            animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')
        ]),
        transition('expanded => collapsed', [
            animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')
        ])
    ])
];